import { SVGProps } from 'react';

export function InfoStroke16(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 16 16'
      width='1em'
      height='1em'
      {...props}
    >
      <g stroke='currentColor'>
        <circle cx='7.5' cy='8.5' r='7' fill='none'></circle>
        <path fill='currentColor' strokeLinecap='round' d='M7.5 12.5V8'></path>
      </g>
      <circle cx='7.5' cy='5' r='1' fill='currentColor'></circle>
    </svg>
  );
}
